import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import { Edit, Save, Cancel } from "@mui/icons-material";
import { CARD_IMG_URL } from "../../../constants";
import { useEffect, useState } from "react";
import { text_field_styles } from "../../../constants/style";
import { Requests } from "../../../common/requests";
import { ENDPOINTS, getApiUrl } from "../../../common/endpoints";
import { useDropzone } from "react-dropzone";
import { useSnackbar } from "notistack";
const CardDialog = ({
  card: cardDetail,
  handleClose,
}: {
  card: any;
  handleClose: () => void;
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [card, setCard] = useState<any>(null);
  const [data, setData] = useState<any>(null);
  const [isEdit, setIsEdit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [file, setFile] = useState<File | null>(null);
  const contents = [
    {
      code: "upright",
      name: "Upright Meaning",
    },
    {
      code: "reversed",
      name: "Reversed Meaning",
    },
    {
      code: "advice",
      name: "Advice Position",
    },
    {
      code: "love",
      name: "Love Position",
    },
    {
      code: "career",
      name: "Career Position",
    },
    {
      code: "yesno",
      name: "Yes or No Card Reading",
    },
  ];

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    setData(card);
  }, [card]);

  const getData = async () => {
    const apiUrl = getApiUrl(
      ENDPOINTS.TAROT_GET_ONE_CARD.replace(":id", cardDetail.id)
    );
    try {
      const data = await Requests.get(apiUrl);
      if (data) {
        setCard(data);
      }
    } catch (e) {}
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setData((prev: any) => ({ ...prev, [name]: value }));
  };

  const onDrop = (acceptedFiles: File[]) => {
    if (acceptedFiles.length > 0) {
      setFile(acceptedFiles[0]); // Set the first dropped file
    }
  };

  const onSave = async () => {
    setIsLoading(true);
    const apiUrl = getApiUrl(
      ENDPOINTS.TAROT_UPDATE_CARD.replace(":id", card.id)
    );
    const dataTemp = { ...data };
    delete dataTemp.file;
    try {
      const dataRes = await Requests.put(
        apiUrl,
        {
          ...dataTemp,
          ...(file ? { file } : {}),
        },
        true,
        false
      );
      setData(dataRes);
      enqueueSnackbar("Save successfully!", { variant: "success" });
    } catch (e) {}
    setIsLoading(false);
    setIsEdit(false);
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      "image/*": [], // Accept all image types
    },
  });
  return (
    <Dialog
      open={Boolean(card)}
      onClose={handleClose}
      sx={{
        "& .MuiPaper-root": {
          maxWidth: "unset",
          width: "800px",
        },
      }}
    >
      <DialogTitle
        color="primary"
        sx={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Typography
          sx={{
            fontWeight: "bold",
          }}
        >
          {card?.title ?? ""}
        </Typography>
        {!isLoading && (
          <>
            {isEdit ? (
              <Box>
                <Button
                  variant="contained"
                  color="primary"
                  sx={{
                    textTransform: "none",
                    fontWeight: "bold",
                  }}
                  onClick={() => {
                    onSave();
                  }}
                >
                  <Save />
                  Save
                </Button>
                <Button
                  sx={{
                    textTransform: "none",
                    fontWeight: "bold",
                  }}
                  onClick={() => {
                    setIsEdit(false);
                    setData(card);
                  }}
                >
                  <Cancel />
                  Cancel
                </Button>
              </Box>
            ) : (
              <Button
                sx={{
                  textTransform: "none",
                  fontWeight: "bold",
                }}
                onClick={() => setIsEdit(true)}
              >
                <Edit />
                Edit
              </Button>
            )}
          </>
        )}
      </DialogTitle>
      <DialogContent>
        {isEdit && (
          <Box
            {...getRootProps({ className: "dropzone" })}
            sx={{
              border: "2px dashed #007bff",
              padding: "20px",
              borderRadius: "4px",
              marginTop: "20px",
              textAlign: "center",
              backgroundColor: isDragActive ? "#f0f8ff" : "#fff", // Change background color on drag
            }}
          >
            <input {...getInputProps()} />
            <Typography>
              {file
                ? `Uploaded: ${file.name}`
                : "Drag 'n' drop some files here, or click to select files"}
            </Typography>
          </Box>
        )}
        <img
          src={data?.file?.url || CARD_IMG_URL.replace("CARD_ID", data?.id)}
          alt={card?.title ?? ""}
          style={{ width: "120px" }}
        />
        {contents.map((content) => (
          <Box
            sx={{
              padding: "10px 0",
            }}
          >
            <Typography
              sx={{
                fontSize: 14,
                fontWeight: "bold",
              }}
            >
              {content?.name ?? ""}
            </Typography>
            {isEdit ? (
              <TextField
                margin="dense"
                name={content?.code}
                label={content?.name ?? ""}
                type="text"
                fullWidth
                variant="outlined"
                multiline
                rows={4}
                value={data?.[content?.code] ?? ""}
                onChange={handleChange}
                sx={{
                  ...text_field_styles,
                }}
              />
            ) : (
              <Typography
                sx={{
                  fontSize: 14,
                  whiteSpace: "pre-line",
                }}
              >
                {card?.[content?.code] ?? ""}
              </Typography>
            )}
          </Box>
        ))}
      </DialogContent>
      <DialogActions>
        <Button
          sx={{
            textTransform: "unset",
          }}
          onClick={handleClose}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CardDialog;
